import { render } from "./region-detail.vue?vue&type=template&id=102517c3"
import script from "./region-detail.vue?vue&type=script&lang=js"
export * from "./region-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__